/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/project/pixinvent
==========================================================================================*/


export default {
  SET_PROJECTS (state, projects) {
    state.projects = projects
  },
  REMOVE_RECORD (state, itemId) {
    const projectIndex = state.projects.findIndex((u) => u.id === itemId)
    state.projects.splice(projectIndex, 1)
  }
}
